module.exports = __webpack_public_path__ + "img/logo-2.b9ee24ba.png";